import { buttonStyle, commonStyles } from 'src/Library/CommonStyles';
import { tokens } from 'src/design-system';

export const DiscoverRatesStyles = (theme) => ({
  searchBackground: {
    backgroundColor: '#E3D3A9',
    padding: `${tokens.spacing.ms}px 0px ${tokens.spacing.xs}px 0px`,
  },
  interSectDiv: {
    minHeight: '100px',
  },
  listDiv: {
    maxHeight: '1102px',
    overflowY: 'auto',
    position: 'relative',
  },
  sortByDiv: {
    ...commonStyles(theme).flexRow,
    marginTop: tokens.spacing.lg,
    fontSize: tokens.fontSize.small,
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '30px',
  },
  noResultText: {
    fontSize: '21px',
    marginTop: '40px',
    textAlign: 'center',
    fontWeight: tokens.fontWeight.semibold,
  },
  viewTabs: {
    backgroundColor: 'rgba(225, 210, 174, 0.1)',
    '& .ant-tabs-bar': {
      margin: 0,
      borderBottom: 'unset',
      padding: '0 2%',
    },
    '& .ant-tabs-nav .ant-tabs-tab': {
      borderBottom: 'none',
      color: '#666666',
      padding: '12px 45%',
      margin: 0,
    },
    '& .ant-tabs-nav .ant-tabs-tab:first-child': {
      padding: '12px 35%',
    },
    '& .ant-tabs-nav .ant-tabs-tab-active': {
      borderBottom: `5px solid ${tokens.colors.textSecondary}`,
      color: tokens.colors.textSecondary,
      fontWeight: 'bold',
    },
    '& .ant-tabs-ink-bar': {
      backgroundColor: tokens.colors.textSecondary,
      width: '0 !important',
    },
  },
  shipperSelect: {
    minWidth: '300px',
    '& .ant-select-selection--single': {
      backgroundColor: '#F5F4F0',
      border: `1px solid ${tokens.colors.border}`,
      boxShadow: 'unset !important',
      '& .ant-select-selection__rendered': {
        '& .ant-select-selection-selected-value': {
          fontWeight: tokens.fontWeight.semibold,
          width: '85%',
        },
        '& .ant-select-search--inline .ant-select-search__field': {
          fontWeight: tokens.fontWeight.semibold,
        },
      },
    },
  },
  dropdown: {
    '& .ant-select-dropdown-menu': {
      '& .ant-select-dropdown-menu-item-selected': {
        backgroundColor: tokens.colors.primaryDark,
        color: tokens.colors.bgWhite,
      },
      '& .ant-select-dropdown-menu-item': {
        fontSize: tokens.fontSize.small,
        '&:hover': {
          backgroundColor: tokens.colors.primaryDark,
          color: tokens.colors.bgWhite,
        },
      },
      '& .ant-select-dropdown-menu-item:first-child': {
        borderBottom: `1px solid ${tokens.colors.border}`,
      },
    },
  },
  shipperTitle: {
    marginRight: tokens.spacing.sm,
    color: '#666666',
  },
  public: {
    fontSize: tokens.fontSize.caption,
    color: '#0A5073',
    backgroundColor: tokens.colors.primaryLight,
    border: '1px solid #CBE3EF',
    borderRadius: tokens.radius.lg,
    lineHeight: '18px',
    padding: `0 ${tokens.spacing.xs}px`,
    marginLeft: tokens.spacing.sm,
  },
  emptyShipperMessage: {
    backgroundColor: '#F5F4F2',
    ...commonStyles(theme).flexColumn,
    alignItems: 'center',
    paddingTop: '10%',
    fontSize: '21px',
  },
  selectShipper: {
    color: tokens.colors.primaryDark,
    marginTop: tokens.spacing.lg,
    fontWeight: tokens.fontWeight.semibold,
  },
  buttonsDiv: {
    display: 'flex',
    marginTop: '17px',
    justifyContent: 'flex-end',
  },
  multipleNegotiateBtn: {
    ...buttonStyle(tokens.colors.textSecondary, 'unset', `1px solid ${tokens.colors.textSecondary}`),
    padding: `0px ${tokens.spacing.md}px`,
    fontSize: tokens.fontSize.small,
    borderRadius: tokens.radius.md,
    fontWeight: tokens.fontWeight.semibold,
  },
  createInquiryButton: {
    ...buttonStyle('#fff', '#1d6ec3', 'unset'),
    padding: `0px 22px`,
    fontSize: tokens.fontSize.body,
    borderRadius: tokens.radius.md,
  },
  customisedRateButton: {
    ...buttonStyle(tokens.colors.bgWhite, tokens.colors.primaryDark, `1px solid ${tokens.colors.primaryDark}`),
    padding: `0 ${tokens.spacing.md}px`,
    fontSize: tokens.fontSize.small,
    borderRadius: tokens.radius.md,
    marginLeft: tokens.spacing.md,
  },
  customisedButtonTooltip: {
    '& .ant-tooltip-inner': {
      backgroundColor: '#000000',
      fontSize: tokens.fontSize.caption,
    },
  },
  cancelButton: {
    color: '#DC3C42',
    fontSize: tokens.fontSize.body,
    fontWeight: tokens.fontWeight.semibold,
    cursor: 'pointer',
    marginLeft: tokens.spacing.xl,
  },
  disabledDiv: {
    pointerEvents: 'none',
    opacity: 0.3,
  },
  disabledCustomisedButton: {
    ...buttonStyle(tokens.colors.bgWhite, '#BBBBBB !important', 'unset'),
    padding: `0 ${tokens.spacing.md}px`,
    marginLeft: tokens.spacing.md,
    fontSize: tokens.fontSize.small,
    borderRadius: tokens.radius.md,
    '& .ant-btn[disabled]': {
      padding: '0 9px',
      backgroundColor: '#BBBBBB !important',
      fontSize: tokens.fontSize.small,
      color: tokens.colors.bgWhite,
    },
  },
  gridOptions: {
    marginTop: '20px',
    display: 'flex',
  },
  portSettings: {
    color: tokens.colors.textSecondary,
    fontSize: tokens.fontSize.small,
    cursor: 'pointer',
    '&:hover': {
      color: tokens.colors.primaryDark,
    },
  },
  portSettingsDisabled: {
    color: tokens.colors.textSecondary,
    fontSize: tokens.fontSize.small,
    pointerEvents: 'none',
    opacity: 0.5,
  },
  portSettingsTitle: {
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  ...commonStyles(theme),
  stickyColumn: {
    width: '90px',
    flex: '0 0 auto',
    position: 'sticky',
    left: '0px',
    backgroundColor: '#f5f4f2',
  },
  portFlag: {
    maxWidth: '15px',
    height: '11px',
  },
  gridContentWrapper: {
    overflow: 'auto',
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'column',
    marginRight: '19px',
    '&::-webkit-scrollbar:vertical': {
      width: '0px',
    },
    '&::-webkit-scrollbar:horizontal': {
      height: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: tokens.radius.lg,
      backgroundColor: '#cccccc',
    },
    '&::-webkit-scrollbar': {
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      appearance: 'none',
    },
  },
  bulkNegotiate: {
    fontWeight: tokens.fontWeight.semibold,
    ...commonStyles(theme).flexRow,
  },
  sortByPartition: {
    marginRight: '10px',
    fontSize: tokens.fontSize.body,
    verticalAlign: 'top',
    lineHeight: '18px',
  },
  trendingSearches: {
    backgroundColor: '#F5F4F2',
    height: '100%',
    padding: '45px 48px',
    overflow: 'auto',
  },
  searchBar: {
    backgroundColor: '#E3D3A9',
    height: '100%',
    padding: '45px 48px',
  },
  shipmentDetails: {
    fontWeight: 'bold',
    fontSize: tokens.fontSize.h1,
    margin: `0 0 ${tokens.spacing.md}px 2%`,
  },
  sendInquiryLabel: {
    fontWeight: tokens.fontWeight.semibold,
    lineHeight: '32px',
  },
  sendInquiryCard: {
    backgroundColor: '#CDD3FF',
    height: '84px',
    maxWidth: '96%',
    padding: `${tokens.spacing.lg}px 0 ${tokens.spacing.lg}px ${tokens.spacing.ms}px`,
    margin: '10px 0',
    overflowX: 'hidden',
  },
  filtersDropDown: {
    fontSize: tokens.fontSize.small,
    color: '#272727',
    padding: `2px ${tokens.spacing.ms}px`,
  },
  transparentSelect: {
    '& > .ant-select-selection': {
      border: "none",
      backgroundColor: "transparent",
      boxShadow: "none",
    },
    '& > .ant-select-selection > .ant-select-selection__rendered': {
      marginLeft: '0px',
    },
    '& > .ant-select-selection > .ant-select-arrow': {
      color: '#6f6f6f',
    },
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    width: '90%',
    border: 'none',
    backgroundColor: 'transparent',
    paddingLeft: '5px',
  },
  viewSelectionDiv: {
    marginRight: '5px',
    display: 'flex',
    alignItems: 'center',
    width: '200px'
  },
  verticalScrollOuterContainer: {
    marginTop: '10px',
    width: '100%',
    position: 'relative',
    isolation: 'isolate',
  },
  verticalScrollWrapper: {
    width: '100%',
    height: 'auto',
    position: 'relative',
    padding: `${tokens.spacing.sm}px 0`,
    overflow: 'hidden',
  },
  verticalScrollContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: tokens.spacing.md,
    overflowX: 'auto',
    overflowY: 'hidden',
    scrollBehavior: 'smooth',
    paddingBottom: '20px',
    paddingLeft: tokens.spacing.sm,
    paddingRight: tokens.spacing.sm,
    scrollbarWidth: 'thin',
    scrollbarColor: '#d9d9d9 #f5f5f5',
    overscrollBehaviorX: 'contain',
    overscrollBehaviorY: 'auto',
    maxWidth: '100%',
    WebkitOverflowScrolling: 'touch',
  },
  verticalScrollCardItem: {
    flex: '0 0 auto',
    width: '300px',
    minWidth: '300px',
    maxWidth: '300px',
  },
});

export const arrowSvg = {
  fill: tokens.colors.primaryDark,
  width: '25px',
  height: '25px',
  transform: 'scale(1)',
  marginTop: '6px',
};
